var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 620.909,
    height: 395.619,
    viewBox: "0 0 620.909 395.619",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2154",
    "data-name": "Rectangle 2154",
    width: 585.457,
    height: 326.704,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33110",
    "data-name": "Trac\\xE9 33110",
    d: "M306.12,179.971a23.116,23.116,0,0,0,0,2.341l-9.634,1.868a1.723,1.723,0,0,0-1.3,2.248l3.191,9.346a1.722,1.722,0,0,0,1.914,1.142l10.183-1.707c10.246,16.088,37.372,28.51,69.789,30.166,42.118,2.15,77.211-14.692,78.381-37.618a23.5,23.5,0,0,0-.828-7.451l6.713-1.529a2.067,2.067,0,0,0,1.386-2.948l-4.363-8.64a2.068,2.068,0,0,0-2.356-1.072l-8.141,2.075c-12.03-13.948-37.11-24.335-66.555-25.839-2.429-.124-4.841-.184-7.219-.184-38.84,0-70.06,16.2-71.163,37.8",
    transform: "translate(-295.093 -142.169)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2130",
    "data-name": "Rectangle 2130",
    width: 197.184,
    height: 87.907,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33116",
    "data-name": "Trac\\xE9 33116",
    d: "M320.41,184.389c0,8.638,12.761,15.641,28.5,15.641s28.5-7,28.5-15.641-12.761-15.642-28.5-15.642-28.5,7-28.5,15.642",
    transform: "translate(-320.41 -168.747)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33119",
    "data-name": "Trac\\xE9 33119",
    d: "M341.611,190.114c0,3.7,5.469,6.7,12.215,6.7s12.216-3,12.216-6.7-5.469-6.7-12.216-6.7-12.215,3-12.215,6.7",
    transform: "translate(-341.611 -183.411)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33122",
    "data-name": "Trac\\xE9 33122",
    d: "M353.348,230.6c0,1.675,2.474,3.032,5.526,3.032s5.526-1.357,5.526-3.032-2.474-3.033-5.526-3.033-5.526,1.357-5.526,3.033",
    transform: "translate(-353.348 -227.564)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33125",
    "data-name": "Trac\\xE9 33125",
    d: "M392.722,219.924c0,1.675,2.474,3.032,5.526,3.032s5.526-1.357,5.526-3.032-2.474-3.032-5.526-3.032-5.526,1.357-5.526,3.032",
    transform: "translate(-392.722 -216.892)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33128",
    "data-name": "Trac\\xE9 33128",
    d: "M421.5,199.949c0,1.675,2.474,3.032,5.526,3.032s5.526-1.357,5.526-3.032-2.475-3.033-5.526-3.033-5.526,1.358-5.526,3.033",
    transform: "translate(-421.496 -196.916)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33131",
    "data-name": "Trac\\xE9 33131",
    d: "M417.331,175.719c0,1.675,2.474,3.032,5.526,3.032s5.525-1.357,5.525-3.032-2.474-3.034-5.525-3.034-5.526,1.358-5.526,3.034",
    transform: "translate(-417.331 -172.685)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33134",
    "data-name": "Trac\\xE9 33134",
    d: "M396.508,159.06c0,1.675,2.474,3.032,5.526,3.032s5.526-1.357,5.526-3.032-2.474-3.033-5.526-3.033-5.526,1.358-5.526,3.033",
    transform: "translate(-396.508 -156.027)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33137",
    "data-name": "Trac\\xE9 33137",
    d: "M360.541,151.488c0,1.675,2.474,3.032,5.526,3.032s5.526-1.357,5.526-3.032-2.474-3.032-5.526-3.032-5.526,1.357-5.526,3.032",
    transform: "translate(-360.541 -148.456)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33140",
    "data-name": "Trac\\xE9 33140",
    d: "M324.953,153.753c0,1.675,2.474,3.033,5.526,3.033s5.526-1.357,5.526-3.033-2.474-3.032-5.526-3.032-5.526,1.358-5.526,3.032",
    transform: "translate(-324.953 -150.721)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33143",
    "data-name": "Trac\\xE9 33143",
    d: "M293.549,164.863c0,1.675,2.474,3.032,5.526,3.032s5.526-1.357,5.526-3.032-2.474-3.032-5.526-3.032-5.526,1.357-5.526,3.032",
    transform: "translate(-293.549 -161.831)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33146",
    "data-name": "Trac\\xE9 33146",
    d: "M279.163,184.246c0,1.675,2.474,3.033,5.526,3.033s5.526-1.358,5.526-3.033-2.474-3.032-5.526-3.032-5.526,1.357-5.526,3.032",
    transform: "translate(-279.163 -181.214)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33149",
    "data-name": "Trac\\xE9 33149",
    d: "M280.677,207.844c0,1.675,2.474,3.033,5.526,3.033s5.526-1.358,5.526-3.033-2.474-3.033-5.526-3.033-5.526,1.358-5.526,3.033",
    transform: "translate(-280.677 -204.811)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33152",
    "data-name": "Trac\\xE9 33152",
    d: "M307.936,226.649c0,1.675,2.474,3.033,5.526,3.033s5.526-1.357,5.526-3.033-2.474-3.033-5.526-3.033-5.526,1.358-5.526,3.033",
    transform: "translate(-307.936 -223.616)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2144",
    "data-name": "Rectangle 2144",
    width: 28.682,
    height: 31.79,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33159",
    "data-name": "Trac\\xE9 33159",
    d: "M111.213,252.987,42.189,330.4a6.06,6.06,0,0,0,.979,8.513c.071.057.144.112.218.166l5.867,4.3,9.348,6.86a6.538,6.538,0,0,0,8.96-1.225l69.025-77.41a6.06,6.06,0,0,0-.979-8.514q-.107-.085-.219-.166l-13.041-9.566-2.174-1.595a6.54,6.54,0,0,0-8.96,1.223",
    transform: "translate(-40.875 -250.517)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2146",
    "data-name": "Rectangle 2146",
    width: 127.07,
    height: 144.106,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2148",
    "data-name": "Rectangle 2148",
    width: 155.624,
    height: 150.887,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2147",
    "data-name": "Rectangle 2147",
    width: 155.618,
    height: 150.881,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2149",
    "data-name": "Rectangle 2149",
    width: 144.109,
    height: 146.509,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2150",
    "data-name": "Rectangle 2150",
    width: 155.624,
    height: 150.885,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2151",
    "data-name": "Rectangle 2151",
    width: 17.218,
    height: 28.395,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2152",
    "data-name": "Rectangle 2152",
    width: 51.865,
    height: 35.208,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8733",
    "data-name": "Groupe 8733",
    transform: "translate(39.815) rotate(7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8732",
    "data-name": "Groupe 8732",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33106",
    "data-name": "Trac\\xE9 33106",
    d: "M517.751,271.248,531.44,384.222l174.03-26.3-14.66-109.779Z",
    transform: "translate(-120.012 -57.517)",
    fill: "#f8cb07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33368",
    "data-name": "Trac\\xE9 33368",
    d: "M22.484-2.19A12.219,12.219,0,0,1,13.8.876,12.219,12.219,0,0,1,5.11-2.19a10.474,10.474,0,0,1-3.285-8.03V-40.953a10.3,10.3,0,0,1,3.322-7.993,12.338,12.338,0,0,1,8.65-3.03,12.338,12.338,0,0,1,8.651,3.03,10.3,10.3,0,0,1,3.321,7.993V-10.22A10.474,10.474,0,0,1,22.484-2.19ZM11.753-8.249a2.922,2.922,0,0,0,2.044.73,2.791,2.791,0,0,0,2.007-.73,2.593,2.593,0,0,0,.766-1.971V-40.88a2.593,2.593,0,0,0-.766-1.971,2.791,2.791,0,0,0-2.007-.73,2.791,2.791,0,0,0-2.007.73,2.593,2.593,0,0,0-.767,1.971v30.66A2.663,2.663,0,0,0,11.753-8.249ZM50.078-2.19A12.219,12.219,0,0,1,41.391.876,12.219,12.219,0,0,1,32.7-2.19a10.474,10.474,0,0,1-3.285-8.03V-40.953a10.3,10.3,0,0,1,3.322-7.993,12.338,12.338,0,0,1,8.65-3.03,12.338,12.338,0,0,1,8.651,3.03,10.3,10.3,0,0,1,3.321,7.993V-10.22A10.474,10.474,0,0,1,50.078-2.19ZM39.347-8.249a2.922,2.922,0,0,0,2.044.73,2.791,2.791,0,0,0,2.007-.73,2.593,2.593,0,0,0,.767-1.971V-40.88a2.593,2.593,0,0,0-.767-1.971,2.791,2.791,0,0,0-2.007-.73,2.791,2.791,0,0,0-2.007.73,2.593,2.593,0,0,0-.766,1.971v30.66A2.663,2.663,0,0,0,39.347-8.249ZM69.788-51.1a11.715,11.715,0,0,1,8.249,2.883,9.864,9.864,0,0,1,3.139,7.628v12.045a9.864,9.864,0,0,1-3.139,7.628,11.715,11.715,0,0,1-8.249,2.884H66.5V-2.117A1.9,1.9,0,0,1,64.313,0H59.422a1.871,1.871,0,0,1-2.117-2.117V-48.983A1.871,1.871,0,0,1,59.422-51.1Zm2.19,21.973V-40a2.593,2.593,0,0,0-.766-1.971A2.791,2.791,0,0,0,69.2-42.7H66.5v16.279h2.7a2.791,2.791,0,0,0,2.007-.73A2.593,2.593,0,0,0,71.978-29.127Zm23.287,30A12.117,12.117,0,0,1,86.651-2.19a10.474,10.474,0,0,1-3.285-8.03V-15.7a1.871,1.871,0,0,1,2.117-2.117h4.891a1.9,1.9,0,0,1,2.19,2.117v5.475a2.663,2.663,0,0,0,.73,1.971,2.663,2.663,0,0,0,1.971.73,2.791,2.791,0,0,0,2.007-.73,2.593,2.593,0,0,0,.767-1.971v-5.913a4.285,4.285,0,0,0-1.5-3.066,21.04,21.04,0,0,0-3.614-2.774q-2.117-1.314-4.271-2.884a13.378,13.378,0,0,1-3.65-4.125,11.338,11.338,0,0,1-1.5-5.84v-6.132a10.476,10.476,0,0,1,3.212-7.993,11.939,11.939,0,0,1,8.541-3.03,12.071,12.071,0,0,1,8.577,3.03,10.416,10.416,0,0,1,3.249,7.993v4.672a1.871,1.871,0,0,1-2.117,2.117H100.01a1.871,1.871,0,0,1-2.117-2.117v-4.745a2.446,2.446,0,0,0-.73-1.861,2.643,2.643,0,0,0-1.9-.694,2.516,2.516,0,0,0-1.861.694,2.516,2.516,0,0,0-.694,1.861v5.11a4.349,4.349,0,0,0,1.5,3.139A20.472,20.472,0,0,0,97.856-30q2.154,1.314,4.271,2.847a13.166,13.166,0,0,1,3.614,4.088,11.338,11.338,0,0,1,1.5,5.84v7.008a10.474,10.474,0,0,1-3.285,8.03A12.219,12.219,0,0,1,95.265.876Z",
    transform: "matrix(0.99, -0.138, 0.138, 0.99, 439.56, 291.749)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8645",
    "data-name": "Groupe 8645"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8644",
    "data-name": "Groupe 8644",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33107",
    "data-name": "Trac\\xE9 33107",
    d: "M472.7,180.857c0,28.532-42.493,51.661-94.912,51.661s-94.912-23.129-94.912-51.661S325.365,129.2,377.784,129.2,472.7,152.325,472.7,180.857",
    transform: "translate(-65.568 -29.947)",
    fill: "#464547"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33108",
    "data-name": "Trac\\xE9 33108",
    d: "M465.917,175.829l-4.363-8.64a2.069,2.069,0,0,0-2.356-1.072l-8.142,2.075c-12.03-13.948-37.11-24.335-66.554-25.838-42.118-2.15-77.211,14.691-78.381,37.617a23.116,23.116,0,0,0,0,2.341l-9.634,1.868a1.722,1.722,0,0,0-1.3,2.247l3.19,9.346a1.721,1.721,0,0,0,1.914,1.142l10.183-1.706c10.246,16.087,37.372,28.51,69.788,30.165,42.119,2.15,77.211-14.692,78.382-37.617a23.523,23.523,0,0,0-.829-7.452l6.714-1.53a2.068,2.068,0,0,0,1.386-2.948",
    transform: "translate(-68.401 -32.954)",
    fill: "#302e2f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8647",
    "data-name": "Groupe 8647",
    transform: "translate(226.692 109.215)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8646",
    "data-name": "Groupe 8646",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33109",
    "data-name": "Trac\\xE9 33109",
    d: "M465.827,188.8l-4.363-8.64a2.069,2.069,0,0,0-2.356-1.072l-8.142,2.075c-12.03-13.948-37.11-24.335-66.554-25.838-42.118-2.15-77.211,14.691-78.381,37.617a23.116,23.116,0,0,0,0,2.341l-9.634,1.868a1.722,1.722,0,0,0-1.3,2.247l3.19,9.346a1.721,1.721,0,0,0,1.914,1.142l10.183-1.706c10.246,16.087,37.372,28.51,69.788,30.165,42.119,2.15,77.212-14.692,78.382-37.617a23.479,23.479,0,0,0-.829-7.452l6.714-1.529a2.068,2.068,0,0,0,1.386-2.948",
    transform: "translate(-295.072 -145.176)",
    fill: "#151311"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8652",
    "data-name": "Groupe 8652"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8651",
    "data-name": "Groupe 8651",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8650",
    "data-name": "Groupe 8650",
    transform: "translate(182.078 124.864)",
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8649",
    "data-name": "Groupe 8649"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8648",
    "data-name": "Groupe 8648",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33111",
    "data-name": "Trac\\xE9 33111",
    d: "M237.018,206.494c0,24.275,44.141,43.954,98.592,43.954S434.2,230.769,434.2,206.494,390.061,162.54,335.61,162.54s-98.592,19.678-98.592,43.954",
    transform: "translate(-237.018 -162.54)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33112",
    "data-name": "Trac\\xE9 33112",
    d: "M414.206,178.772v-5.407l-2.929.273-2.123-3.72a2.176,2.176,0,0,0-2.535-1l-8.452,2.62c-13.4-14.024-40.337-23.6-71.385-23.6-42.764,0-77.727,18.17-80.264,41.1l-11.436,1.069.111,7.687a1.8,1.8,0,0,0,.018,1.292l3.858,9.659a1.812,1.812,0,0,0,2.074,1.1l10.619-2.341c11.64,16.37,40.837,27.979,75.019,27.979,44.414,0,80.418-19.6,80.418-43.772a24.764,24.764,0,0,0-1.271-7.792l6.978-1.97a2.177,2.177,0,0,0,1.3-3.174",
    transform: "translate(-54.491 -34.291)",
    fill: "#302f30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33113",
    "data-name": "Trac\\xE9 33113",
    d: "M414.206,168.928l-5.052-8.853a2.176,2.176,0,0,0-2.535-1l-8.452,2.62c-13.4-14.024-40.337-23.6-71.385-23.6-44.413,0-80.417,19.6-80.417,43.772a24.318,24.318,0,0,0,.129,2.463l-10.033,2.481a1.813,1.813,0,0,0-1.249,2.433l3.857,9.659a1.814,1.814,0,0,0,2.075,1.1l10.619-2.341c11.64,16.37,40.837,27.979,75.019,27.979,44.414,0,80.418-19.6,80.418-43.772a24.763,24.763,0,0,0-1.271-7.792l6.978-1.97a2.177,2.177,0,0,0,1.3-3.174",
    transform: "translate(-54.491 -32.009)",
    fill: "#464547"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33114",
    "data-name": "Trac\\xE9 33114",
    d: "M377.415,184.389c0,8.638-12.761,15.641-28.5,15.641s-28.5-7-28.5-15.641,12.761-15.641,28.5-15.641,28.5,7,28.5,15.641",
    transform: "translate(-74.269 -39.115)",
    fill: "#302f30"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8654",
    "data-name": "Groupe 8654",
    transform: "translate(246.141 129.632)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8653",
    "data-name": "Groupe 8653",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33115",
    "data-name": "Trac\\xE9 33115",
    d: "M377.415,192.351c0,8.638-12.761,15.641-28.5,15.641s-28.5-7-28.5-15.641,12.761-15.641,28.5-15.641,28.5,7,28.5,15.641",
    transform: "translate(-320.41 -170.593)",
    fill: "#464547"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8656",
    "data-name": "Groupe 8656"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8655",
    "data-name": "Groupe 8655",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33117",
    "data-name": "Trac\\xE9 33117",
    d: "M366.042,190.114c0,3.7-5.469,6.7-12.215,6.7s-12.215-3-12.215-6.7,5.469-6.7,12.215-6.7,12.215,3,12.215,6.7",
    transform: "translate(-79.184 -42.514)",
    fill: "#302f30"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8658",
    "data-name": "Groupe 8658",
    transform: "translate(262.427 140.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8657",
    "data-name": "Groupe 8657",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33118",
    "data-name": "Trac\\xE9 33118",
    d: "M366.042,193.527c0,3.7-5.469,6.7-12.215,6.7s-12.215-3-12.215-6.7,5.469-6.7,12.215-6.7,12.215,3,12.215,6.7",
    transform: "translate(-341.611 -184.202)",
    fill: "#373637"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8660",
    "data-name": "Groupe 8660"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8659",
    "data-name": "Groupe 8659",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33120",
    "data-name": "Trac\\xE9 33120",
    d: "M364.4,230.6c0,1.675-2.474,3.033-5.526,3.033s-5.526-1.358-5.526-3.033,2.474-3.033,5.526-3.033,5.526,1.358,5.526,3.033",
    transform: "translate(-81.904 -52.748)",
    fill: "#302f30"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8662",
    "data-name": "Groupe 8662",
    transform: "translate(271.444 174.816)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8661",
    "data-name": "Groupe 8661",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33121",
    "data-name": "Trac\\xE9 33121",
    d: "M364.4,232.14c0,1.675-2.474,3.034-5.526,3.034s-5.526-1.358-5.526-3.034,2.474-3.033,5.526-3.033,5.526,1.359,5.526,3.033",
    transform: "translate(-353.348 -227.922)",
    fill: "#373637"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8664",
    "data-name": "Groupe 8664"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8663",
    "data-name": "Groupe 8663",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33123",
    "data-name": "Trac\\xE9 33123",
    d: "M403.774,219.924c0,1.675-2.474,3.033-5.526,3.033s-5.526-1.358-5.526-3.033,2.474-3.033,5.526-3.033,5.526,1.358,5.526,3.033",
    transform: "translate(-91.031 -50.274)",
    fill: "#302f30"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8666",
    "data-name": "Groupe 8666",
    transform: "translate(301.691 166.617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8665",
    "data-name": "Groupe 8665",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33124",
    "data-name": "Trac\\xE9 33124",
    d: "M403.774,221.468c0,1.675-2.474,3.033-5.526,3.033s-5.526-1.358-5.526-3.033,2.474-3.033,5.526-3.033,5.526,1.358,5.526,3.033",
    transform: "translate(-392.722 -217.25)",
    fill: "#373637"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8668",
    "data-name": "Groupe 8668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8667",
    "data-name": "Groupe 8667",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33126",
    "data-name": "Trac\\xE9 33126",
    d: "M432.547,199.949c0,1.675-2.474,3.033-5.526,3.033s-5.526-1.358-5.526-3.033,2.474-3.033,5.526-3.033,5.526,1.358,5.526,3.033",
    transform: "translate(-97.7 -45.644)",
    fill: "#302f30"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8670",
    "data-name": "Groupe 8670",
    transform: "translate(323.795 151.272)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8669",
    "data-name": "Groupe 8669",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33127",
    "data-name": "Trac\\xE9 33127",
    d: "M432.547,201.492c0,1.675-2.474,3.033-5.526,3.033s-5.526-1.358-5.526-3.033,2.474-3.033,5.526-3.033,5.526,1.358,5.526,3.033",
    transform: "translate(-421.496 -197.274)",
    fill: "#373637"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8672",
    "data-name": "Groupe 8672"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8671",
    "data-name": "Groupe 8671",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33129",
    "data-name": "Trac\\xE9 33129",
    d: "M428.383,175.718c0,1.675-2.474,3.033-5.526,3.033s-5.526-1.358-5.526-3.033,2.474-3.033,5.526-3.033,5.526,1.358,5.526,3.033",
    transform: "translate(-96.735 -40.028)",
    fill: "#302f30"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8674",
    "data-name": "Groupe 8674",
    transform: "translate(320.596 132.657)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8673",
    "data-name": "Groupe 8673",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33130",
    "data-name": "Trac\\xE9 33130",
    d: "M428.383,177.262c0,1.675-2.474,3.033-5.526,3.033s-5.526-1.358-5.526-3.033,2.474-3.033,5.526-3.033,5.526,1.358,5.526,3.033",
    transform: "translate(-417.331 -173.043)",
    fill: "#373637"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8676",
    "data-name": "Groupe 8676"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8675",
    "data-name": "Groupe 8675",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33132",
    "data-name": "Trac\\xE9 33132",
    d: "M407.56,159.06c0,1.675-2.474,3.033-5.526,3.033s-5.526-1.358-5.526-3.033,2.474-3.033,5.526-3.033,5.526,1.358,5.526,3.033",
    transform: "translate(-91.909 -36.166)",
    fill: "#302f30"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8678",
    "data-name": "Groupe 8678",
    transform: "translate(304.599 119.861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8677",
    "data-name": "Groupe 8677",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33133",
    "data-name": "Trac\\xE9 33133",
    d: "M407.56,160.6c0,1.675-2.474,3.033-5.526,3.033s-5.526-1.358-5.526-3.033,2.474-3.033,5.526-3.033,5.526,1.358,5.526,3.033",
    transform: "translate(-396.508 -156.385)",
    fill: "#373637"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8680",
    "data-name": "Groupe 8680"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8679",
    "data-name": "Groupe 8679",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33135",
    "data-name": "Trac\\xE9 33135",
    d: "M371.593,151.488c0,1.675-2.474,3.033-5.526,3.033s-5.526-1.358-5.526-3.033,2.474-3.033,5.526-3.033,5.526,1.358,5.526,3.033",
    transform: "translate(-83.572 -34.411)",
    fill: "#302f30"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8682",
    "data-name": "Groupe 8682",
    transform: "translate(276.969 114.045)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8681",
    "data-name": "Groupe 8681",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33136",
    "data-name": "Trac\\xE9 33136",
    d: "M371.593,153.032c0,1.675-2.474,3.033-5.526,3.033s-5.526-1.358-5.526-3.033S363.015,150,366.067,150s5.526,1.358,5.526,3.033",
    transform: "translate(-360.541 -148.814)",
    fill: "#373637"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8684",
    "data-name": "Groupe 8684"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8683",
    "data-name": "Groupe 8683",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33138",
    "data-name": "Trac\\xE9 33138",
    d: "M336.005,153.753c0,1.675-2.474,3.033-5.526,3.033s-5.526-1.358-5.526-3.033,2.474-3.033,5.526-3.033,5.526,1.358,5.526,3.033",
    transform: "translate(-75.323 -34.936)",
    fill: "#302f30"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8686",
    "data-name": "Groupe 8686",
    transform: "translate(249.63 115.785)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8685",
    "data-name": "Groupe 8685",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33139",
    "data-name": "Trac\\xE9 33139",
    d: "M336.005,155.3c0,1.675-2.474,3.033-5.526,3.033s-5.526-1.358-5.526-3.033,2.474-3.033,5.526-3.033,5.526,1.358,5.526,3.033",
    transform: "translate(-324.953 -151.079)",
    fill: "#373637"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8688",
    "data-name": "Groupe 8688"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8687",
    "data-name": "Groupe 8687",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33141",
    "data-name": "Trac\\xE9 33141",
    d: "M304.6,164.863c0,1.675-2.474,3.033-5.526,3.033s-5.526-1.358-5.526-3.033,2.474-3.033,5.526-3.033,5.526,1.358,5.526,3.033",
    transform: "translate(-68.043 -37.511)",
    fill: "#302f30"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8690",
    "data-name": "Groupe 8690",
    transform: "translate(225.506 124.319)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8689",
    "data-name": "Groupe 8689",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33142",
    "data-name": "Trac\\xE9 33142",
    d: "M304.6,166.407c0,1.675-2.474,3.033-5.526,3.033s-5.526-1.358-5.526-3.033,2.474-3.033,5.526-3.033,5.526,1.358,5.526,3.033",
    transform: "translate(-293.549 -162.189)",
    fill: "#373637"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8692",
    "data-name": "Groupe 8692"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8691",
    "data-name": "Groupe 8691",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33144",
    "data-name": "Trac\\xE9 33144",
    d: "M290.214,184.246c0,1.675-2.474,3.033-5.526,3.033s-5.526-1.358-5.526-3.033,2.474-3.033,5.526-3.033,5.526,1.358,5.526,3.033",
    transform: "translate(-64.708 -42.004)",
    fill: "#302f30"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8694",
    "data-name": "Groupe 8694",
    transform: "translate(214.454 139.209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8693",
    "data-name": "Groupe 8693",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33145",
    "data-name": "Trac\\xE9 33145",
    d: "M290.214,185.79c0,1.675-2.474,3.033-5.526,3.033s-5.526-1.358-5.526-3.033,2.474-3.033,5.526-3.033,5.526,1.358,5.526,3.033",
    transform: "translate(-279.163 -181.572)",
    fill: "#373637"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8696",
    "data-name": "Groupe 8696"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8695",
    "data-name": "Groupe 8695",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33147",
    "data-name": "Trac\\xE9 33147",
    d: "M291.729,207.844c0,1.675-2.474,3.033-5.526,3.033s-5.526-1.358-5.526-3.033,2.474-3.033,5.526-3.033,5.526,1.358,5.526,3.033",
    transform: "translate(-65.06 -47.474)",
    fill: "#302f30"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8698",
    "data-name": "Groupe 8698",
    transform: "translate(215.617 157.337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8697",
    "data-name": "Groupe 8697",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33148",
    "data-name": "Trac\\xE9 33148",
    d: "M291.729,209.388c0,1.675-2.474,3.033-5.526,3.033s-5.526-1.358-5.526-3.033,2.474-3.033,5.526-3.033,5.526,1.358,5.526,3.033",
    transform: "translate(-280.677 -205.169)",
    fill: "#373637"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8700",
    "data-name": "Groupe 8700"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8699",
    "data-name": "Groupe 8699",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33150",
    "data-name": "Trac\\xE9 33150",
    d: "M318.988,226.649c0,1.675-2.474,3.033-5.526,3.033s-5.526-1.358-5.526-3.033,2.474-3.033,5.526-3.033,5.526,1.358,5.526,3.033",
    transform: "translate(-71.378 -51.833)",
    fill: "#302f30"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8702",
    "data-name": "Groupe 8702",
    transform: "translate(236.558 171.783)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8701",
    "data-name": "Groupe 8701",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33151",
    "data-name": "Trac\\xE9 33151",
    d: "M318.988,228.193c0,1.675-2.474,3.033-5.526,3.033s-5.526-1.358-5.526-3.033,2.474-3.033,5.526-3.033,5.526,1.358,5.526,3.033",
    transform: "translate(-307.936 -223.974)",
    fill: "#373637"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8707",
    "data-name": "Groupe 8707"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8706",
    "data-name": "Groupe 8706",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33153",
    "data-name": "Trac\\xE9 33153",
    d: "M605.431,70.029A16.061,16.061,0,0,1,622.546,70l15.591,9q8.535,4.928-.054,9.881l-5.033,2.905,34.123,19.7q8.535,4.927-.054,9.881l-19.832,11.45q-8.881,5.128-17.411.2l-34.122-19.7-42.625,24.609a16.048,16.048,0,0,1-17.114.031l-13.237-7.642a34.093,34.093,0,0,1-8.817-6.8L426.53,31q-4.984-5.609,2.415-9.886L461.21,2.486a16.059,16.059,0,0,1,17.114-.031L600.4,72.934ZM491.005,58.311l49.6,49.145,22.5-12.988L495.741,55.577,476.053,40.449l-4.737,2.735Z",
    transform: "translate(-98.403 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33154",
    "data-name": "Trac\\xE9 33154",
    d: "M270.382,289.215a16.061,16.061,0,0,1,17.115-.031l15.591,9q8.535,4.928-.054,9.881L298,310.972l34.123,19.7q8.535,4.927-.054,9.881L312.238,352q-8.881,5.128-17.411.2L260.7,332.5,218.08,357.114a16.048,16.048,0,0,1-17.114.031L187.729,349.5a34.093,34.093,0,0,1-8.817-6.8L91.481,250.186Q86.5,244.576,93.9,240.3l32.265-18.627a16.059,16.059,0,0,1,17.114-.031L265.35,292.12ZM155.956,277.5l49.6,49.145,22.5-12.988-67.361-38.891L141,259.635l-4.737,2.735Z",
    transform: "translate(-20.74 -50.806)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33155",
    "data-name": "Trac\\xE9 33155",
    d: "M143.693,223.593l14.553,10.67-89.7,103.8-14.553-10.67Z",
    transform: "translate(-12.514 -51.828)",
    fill: "#1d2737"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8705",
    "data-name": "Groupe 8705",
    transform: "translate(108.221 171.765)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8704",
    "data-name": "Groupe 8704"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8703",
    "data-name": "Groupe 8703",
    clipPath: "url(#clip-path-32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33156",
    "data-name": "Trac\\xE9 33156",
    d: "M169.556,227.79l-25.315,27.593-3.366-3.747,22.958-28.043Z",
    transform: "translate(-140.875 -223.593)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33157",
    "data-name": "Trac\\xE9 33157",
    d: "M43.387,339.076c-.075-.054-.147-.109-.22-.166a6.06,6.06,0,0,1-.979-8.513l69.024-77.409a6.541,6.541,0,0,1,8.96-1.224l2.174,1.595,13.041,9.566q.112.081.219.166a6.059,6.059,0,0,1,.979,8.513L67.56,349.015A6.536,6.536,0,0,1,58.6,350.24l-9.349-6.86Z",
    transform: "translate(-9.475 -58.069)",
    fill: "#26282e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8712",
    "data-name": "Groupe 8712",
    transform: "translate(31.401 192.448)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8711",
    "data-name": "Groupe 8711",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8710",
    "data-name": "Groupe 8710",
    transform: "translate(-31.401 -27.296)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8709",
    "data-name": "Groupe 8709"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8708",
    "data-name": "Groupe 8708",
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33158",
    "data-name": "Trac\\xE9 33158",
    d: "M78.04,214.985,0,312.087l11.346,47c53.692-67.857,68.227-77.66,80.066-89a194.962,194.962,0,0,1,20.175-16.705,163.727,163.727,0,0,1,15.482-9.633v-2.082L78.04,214.985",
    transform: "translate(0 -214.985)",
    fill: "#040405"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8731",
    "data-name": "Groupe 8731"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8730",
    "data-name": "Groupe 8730",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33160",
    "data-name": "Trac\\xE9 33160",
    d: "M275.513,66.194q1.5,1.085,2.956,2.239A81.9,81.9,0,0,1,291.712,183.5,88.421,88.421,0,0,1,170.6,200.058a81.988,81.988,0,0,1-33.307-76.453A73.879,73.879,0,0,0,167.7,188.1a79.62,79.62,0,0,0,109.061-14.9q1.039-1.31,2.018-2.665a73.753,73.753,0,0,0-16.6-102.972A79.653,79.653,0,0,0,181.6,59.919a88.533,88.533,0,0,1,93.908,6.275",
    transform: "translate(-31.68 -11.438)",
    fill: "#1b1c1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33161",
    "data-name": "Trac\\xE9 33161",
    d: "M264.934,59.308A88.422,88.422,0,0,0,143.818,75.865a81.9,81.9,0,0,0,13.237,115.07q1.455,1.156,2.962,2.244a88.422,88.422,0,0,0,121.116-16.556A81.9,81.9,0,0,0,267.9,61.552q-1.455-1.156-2.962-2.244m9.365,112.3a79.622,79.622,0,0,1-109.061,14.91A73.751,73.751,0,0,1,148.632,83.549q.979-1.356,2.02-2.668A79.621,79.621,0,0,1,259.713,65.972,73.751,73.751,0,0,1,276.32,168.94q-.979,1.356-2.02,2.667",
    transform: "translate(-29.221 -9.844)",
    fill: "#26282e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8717",
    "data-name": "Groupe 8717",
    transform: "translate(105.445 40.954)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8716",
    "data-name": "Groupe 8716"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8715",
    "data-name": "Groupe 8715",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8714",
    "data-name": "Groupe 8714",
    transform: "translate(0.002 0.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8713",
    "data-name": "Groupe 8713",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33162",
    "data-name": "Trac\\xE9 33162",
    d: "M153.247,83.385a79.622,79.622,0,0,1,109.061-14.91q1.362.984,2.678,2.029a73.751,73.751,0,0,1,11.908,103.617,79.621,79.621,0,0,1-109.061,14.909q-1.356-.979-2.667-2.02A73.75,73.75,0,0,1,153.247,83.395",
    transform: "translate(-137.263 -53.317)",
    fill: "#b5d1e9"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8720",
    "data-name": "Groupe 8720",
    transform: "translate(116.955 45.311)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8719",
    "data-name": "Groupe 8719"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8718",
    "data-name": "Groupe 8718",
    clipPath: "url(#clip-path-38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33163",
    "data-name": "Trac\\xE9 33163",
    d: "M212.916,205.33C166,191.719,142.282,142.357,156.2,105.268c12.518-33.346,54.826-55.08,97.2-42.83A79.866,79.866,0,0,1,265.782,69.8q1.356.979,2.667,2.02a73.75,73.75,0,0,1,11.919,103.615,79.543,79.543,0,0,1-67.452,29.895",
    transform: "translate(-152.245 -58.983)",
    fill: "#e5e5e9"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33164",
    "data-name": "Trac\\xE9 33164",
    d: "M152.73,103.957c-13.921,37.089,9.8,86.451,56.712,100.062a79.256,79.256,0,0,1-41.609-14.985q-1.356-.979-2.667-2.02A73.751,73.751,0,0,1,153.247,83.4v-.008A79.606,79.606,0,0,1,249.93,61.128c-42.373-12.25-84.682,9.483-97.2,42.829",
    transform: "translate(-31.816 -12.361)",
    fill: "#5f7788"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8723",
    "data-name": "Groupe 8723",
    transform: "translate(105.445 40.954)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8722",
    "data-name": "Groupe 8722"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8721",
    "data-name": "Groupe 8721",
    clipPath: "url(#clip-path-39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33165",
    "data-name": "Trac\\xE9 33165",
    d: "M153.247,83.385a79.622,79.622,0,0,1,109.061-14.91q1.362.984,2.678,2.029a73.751,73.751,0,0,1,11.908,103.617,79.621,79.621,0,0,1-109.061,14.909q-1.356-.979-2.667-2.02A73.75,73.75,0,0,1,153.247,83.395",
    transform: "translate(-137.261 -53.311)",
    fill: "#b5d1e9"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33166",
    "data-name": "Trac\\xE9 33166",
    d: "M58.13,359.893c-6.829-5.281-14.233-7.137-16.556-4.141s1.334,9.7,8.162,14.985,14.233,7.136,16.556,4.141-1.337-9.7-8.162-14.985",
    transform: "translate(-9.475 -82.13)",
    fill: "#1b1c1f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8726",
    "data-name": "Groupe 8726",
    transform: "translate(133.55 87.794)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8725",
    "data-name": "Groupe 8725"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8724",
    "data-name": "Groupe 8724",
    clipPath: "url(#clip-path-40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33167",
    "data-name": "Trac\\xE9 33167",
    d: "M188.793,114.537c-3.217-1.463-8.662,3.6-12.163,11.3s-3.729,15.131-.512,16.593,8.662-3.594,12.163-11.3,3.729-15.133.512-16.595",
    transform: "translate(-173.847 -114.285)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8729",
    "data-name": "Groupe 8729",
    transform: "translate(162.375 58.321)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8728",
    "data-name": "Groupe 8728"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8727",
    "data-name": "Groupe 8727",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33168",
    "data-name": "Trac\\xE9 33168",
    d: "M262.619,84.985c-3.087-8.508-16.922-11.568-30.9-6.852S208.9,93.552,211.984,102.06s16.923,11.568,30.9,6.852,22.816-15.429,19.73-23.927",
    transform: "translate(-211.37 -75.919)",
    fill: "#fff"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.5c2aa78631e4e2fb8e060c4a30a7b203.svg";
export { ForwardRef as ReactComponent };